import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import template from './right-side-alert-current-lot.vue';
import { LiveData } from '../../views/live/index';

@Component({
    mixins: [template],
})
export default class RightSideAlertCurrentLot extends Vue {
    @Prop(Object) readonly auctionData!: LiveData;

    private hasAlerts: boolean = false;
    private isUnavailable: boolean = false;

    @Watch('auctionData.lots')
    @Watch('$store.state.currentShownLot')
    @Watch('auctionData.activeLot')
    updateCurrentLotAlert() {
        this.hasAlerts = false;
        if (this.$store.state.currentShownLot === this.auctionData.activeLot &&
            typeof this.$store.state.currentShownLot !== 'undefined' &&
            this.auctionData.lots[this.$store.state.currentShownLot]
        ) {
            const lot = this.auctionData.lots[this.$store.state.currentShownLot]
            this.isUnavailable = lot.isUnavailable && !lot.sold

            this.hasAlerts = this.isUnavailable;
        }
    }

    constructor() {
        super();
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/components/right-side-alert-current-lot/index.ts